import { Pagination as APagination } from '@ark-ui/solid/pagination';
import { IconChevronLeft } from '@bbr/icons/chevron-left-outline';
import { IconChevronRight } from '@bbr/icons/chevron-right-outline';
import { For, Show, splitProps } from 'solid-js';
import { Button } from '../forms/button.tsx';
import { Link } from './link.tsx';
import type { ComponentProps } from 'solid-js';

type Props = ComponentProps<typeof APagination.Root> & {
	nextTitle?: string;
	prevTitle?: string;
};

export function Pagination(props: Props) {
	const [, spread] = splitProps(props, ['nextTitle', 'prevTitle']);

	return (
		<APagination.Root type="link" {...spread} class="flex w-full flex-wrap items-center justify-between gap-4">
			<APagination.PrevTrigger
				asChild={(p) => (
					// @ts-expect-error spread not good with button
					<Button {...p()} as={Link} size="md" rounding="md" appearance="subtle" icon={IconChevronLeft} />
				)}
			>
				{props.prevTitle ?? 'Previous'}
			</APagination.PrevTrigger>

			<APagination.Context>
				{(pagination) => (
					<div class="flex grow flex-wrap items-center justify-center gap-2">
						<For each={pagination().pages}>
							{(page, index) => (
								<Show
									when={page.type === 'page' && page}
									fallback={<APagination.Ellipsis index={index()}>&#8230;</APagination.Ellipsis>}
								>
									{(page) => (
										<APagination.Item
											{...page()}
											asChild={(p) => (
												// @ts-expect-error spread not good with button
												<Button
													{...p()}
													as={Link}
													size="md"
													rounding="md"
													appearance={page().value === props.page ? 'outline' : 'subtle'}
												/>
											)}
										>
											{page().value}
										</APagination.Item>
									)}
								</Show>
							)}
						</For>
					</div>
				)}
			</APagination.Context>

			<APagination.NextTrigger
				asChild={(p) => (
					// @ts-expect-error spread not good with button
					<Button
						{...p()}
						as={Link}
						size="md"
						rounding="md"
						appearance="subtle"
						icon={IconChevronRight}
						iconPosition="end"
					/>
				)}
			>
				{props.nextTitle ?? 'Next'}
			</APagination.NextTrigger>
		</APagination.Root>
	);
}
